module Client.Components.ContactInfo

open Shared
open global.Elmish
open Feliz
open Feliz.MaterialUI
open CustomerDexImaging.Models

let view (contactSelectionInfo : ContactSelectionInfo) =
  Html.div [
    match contactSelectionInfo with
    | Contact contact ->
      Mui.grid [
        grid.container true
        grid.direction.column
        grid.spacing._2
        grid.children [
          Mui.grid [
            grid.item true
            grid.children [
              Mui.textField [
                textField.placeholder "Email"
                textField.value contact.Email
                textField.variant.filled
                textField.margin.normal
                textField.fullWidth true
                textField.label "Email"
                textField.name "Email"
              ]
            ]
          ]
        ]
      ]
    | NewContact contact ->
      Mui.grid [
        grid.item true
        grid.children [
          Html.form [
            prop.children [
              Mui.textField [
                textField.placeholder "Email"
                textField.variant.filled
                textField.value contact.Email
                textField.margin.normal
                textField.fullWidth true
                textField.label "Email"
                textField.name "Email"
                textField.required true
              ]
              Mui.textField [
                textField.placeholder "First name"
                textField.variant.filled
                textField.value contact.FirstName
                textField.margin.normal
                textField.fullWidth true
                textField.label "First name"
                textField.name "FirstName"
                textField.required true
              ]
              Mui.textField [
                textField.placeholder "Middle name"
                textField.variant.filled
                textField.value contact.MiddleName
                textField.margin.normal
                textField.fullWidth true
                textField.label "Middle name"
                textField.name "MiddleName"
                textField.required true
              ]
              Mui.textField [
                textField.placeholder "Last name"
                textField.variant.filled
                textField.value contact.LastName
                textField.margin.normal
                textField.fullWidth true
                textField.label "Last name"
                textField.name "LastName"
                textField.required true
              ]
              Mui.textField [
                textField.placeholder "Phone"
                textField.variant.filled
                textField.value contact.Phone
                textField.margin.normal
                textField.fullWidth true
                textField.label "Phone"
                textField.name "Phone"
                textField.required true
              ]
            ]
          ]
        ]
      ]

  ]